import React from 'react';
import './App.css';
import { Home } from './views/Home';
import { Header } from './components/navigation/Header';
import { Footer } from './components/navigation/Footer';
import { BrowserRouter as Router, Route, Routes } from 'react-router';
import { ThemeProvider } from 'styled-components';
import { theme } from './components/style';
import { AboutUs } from './views/AboutUs';
import { PageNotFound } from './views/PageNotFound';
import { Calculators } from './views/Calculators';
import { Links } from './config/navigation';

const App: React.FC = () => {
  return (
    <div className="container">
      <ThemeProvider theme={theme}>
        <Router>
          <Header />
          <Routes>
            <Route path={Links.Home} element={<Home />} />
            <Route path={Links.AboutUs} element={<AboutUs />} />
            <Route path={Links.Calculators} element={<Calculators />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Footer />
        </Router>
      </ThemeProvider>
    </div>
  );
};

export default App;
